export function castToString(value, defaultValue) {
    if (typeof value === 'string') {
        return value;
    }
    if (value.toString instanceof Function) {
        return value.toString();
    }
    return defaultValue;
}
